"use client";

import { env } from "@copilot/config/env";
import { useTranslate } from "@copilot/i18n";
import { Button } from "@copilot/ui/components/button";
import Image from "next/image";
import Link from "next/link";

export default function NotFound() {
  const { t } = useTranslate();
  const text = t(
    "notFound.text",
    "We can't seem to find the page you're looking for.",
  );
  const buttonText = t("notFound.button", "Go Home");
  return (
    <div className="flex h-dvh w-full flex-col items-center justify-center gap-6 text-center text-[#60646C]">
      <Image
        src="/logo.svg"
        alt={env.NEXT_PUBLIC_BRAND}
        width={24}
        height={24}
      />
      <span>{text}</span>
      <Button className="text-sm" asChild>
        <Link href="/">{buttonText}</Link>
      </Button>
    </div>
  );
}
